import * as moment from 'moment';

export function formatarDataType(data: moment.Moment | string | Date): string {
  // Use moment() to parse the input, which is smart enough to handle various date formats, including ISO 8601.
  const parsedData = moment(data);

  // Check if the parsed date is valid. If not, return an empty string or handle the error.
  if (!parsedData.isValid()) {
    return '';
  }

  // Use moment's own format() method, which is more reliable and concise.
  return parsedData.format('YYYY-MM-DD');
}